.loaderContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .wrapper {
    max-width: 300px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100px;
    flex-direction: column;
    svg {
      fill: var(--text-color);
      gap: var(--fly-space-7);
    }
    .progressBarWrapper {
      height: 4px;
      width: 100%;
      border: var(--fly-number-stroke-1) solid var(--gray-2);
      background: var(--gray-2);
      border-radius: var(--fly-number-radius-9);
      left: 0;
      position: relative;
      top: var(--fly-number-spacing-7);
      overflow: hidden;
      .progressBar {
        height: 100%;
        border-radius: var(--fly-number-radius-9);
        background: linear-gradient(
          to right,
          var(--fly-color-scheme-primary-10) 0%,
          var(--fly-color-scheme-primary-5) 50%,
          var(--fly-color-scheme-primary-10) 100%
        );
        width: 80%;
        position: absolute;
        animation: progressBounce 1s linear infinite alternate;
      }
    }
  }
}
@keyframes progressBounce {
  0% {
    transform: translateX(-200%);
    opacity: 0;
  }
  15% {
    opacity: 1;
  }
  85% {
    opacity: 1;
  }
  100% {
    transform: translateX(300%);
    opacity: 0;
  }
}
